import useTranslation from "hooks/useTranslation";

const ChargeLink = ({ link }) => {
  const { getTranslation } = useTranslation("CHAT");
  const { t } = getTranslation();

  <a
    rel="noreferrer"
    target="_blank"
    className="expire_package_alert__link"
    href={link}
  >
    {" "}
    {t("THIS_LINK")}
  </a>;
};

export default ChargeLink;
